<template>
   <div class="row">
      <div class="col-12">
         <button type="button" class="btn btn-link float-left ml-auto" @click.stop="onAction">{{text}}</button>
      </div>
   </div>
</template>

<script>
export default {
   props: {
      text: {
         type: [String],
         default: "Cancelar"
      }
   },
   data() {
      return {
      }
   },
   methods: {
      async onAction(){
         await this.$emit("on-action")
      }
   }
}
</script>